var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.textConfigs
      ? _vm.textConfigs.label
      : 'font-weight-bold text-h6 mb-1 px-2 text-capitalize unfade',attrs:{"plain":"","color":_vm.colorAccent ? _vm.colorAccent : '',"text":"","x-large":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit(`${_vm.method}`)}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }